import { useTranslation } from 'react-i18next';
import { Button, Icon, Stack, Text } from 'shell/components';

const InquireControls = ({ hasUnreadChat = false, onOpenChat }) => {
    const { t } = useTranslation();

    if (!onOpenChat) return null;

    return (
        <Stack sx={{ px: 3, py: 2 }} alignItems={'center'} direction={'row'} spacing={2}>
            <Button
                badge={hasUnreadChat}
                startIcon={<Icon kind={'messageSparkle'} />}
                variant={'secondary'}
                onClick={onOpenChat}
            >
                {t('controls.inquire', 'Inquire')}
            </Button>
            <Text color={'light'}>{t('inquire-with-ai-feedback', 'Inquire with AI about feedback')}</Text>
        </Stack>
    );
};

export default InquireControls;
